import { Chip, useTheme } from '@mui/material';
import { EIconCategory, getAppIcon } from '@src/helper/iconRegistry';
import React from 'react';

interface AvailabilityBadgeProps {
    availability: number;
    size?: 'small' | 'medium';
    variant?: 'filled' | 'outlined';
}

function AvailabilityBadge({ availability, size = 'small', variant = 'filled' }: AvailabilityBadgeProps) {
    const theme = useTheme();

    const getAvailabilityColor = (availability: number) => {
        if (availability >= 60) return 'success';
        if (availability >= 34) return 'warning';
        return 'error';
    };

    const getAvailabilityThemeColor = (availability: number) => {
        if (availability >= 60) return theme.palette.success;
        if (availability >= 34) return theme.palette.warning;
        return theme.palette.error;
    };

    const color = getAvailabilityColor(availability);
    const themeColor = getAvailabilityThemeColor(availability);

    return (
        <Chip
            icon={getAppIcon(EIconCategory.AVAILABILITY)}
            label={`${availability}%`}
            size={size}
            color={color}
            variant={variant}
            sx={{
                fontWeight: 500,
                px: 1,
                ...(variant === 'filled' && {
                    bgcolor: themeColor.main,
                    color: themeColor.contrastText,
                    '& .MuiChip-icon': {
                        color: themeColor.contrastText,
                        fontSize: '14px',
                    },
                }),
                ...(variant === 'outlined' && {
                    borderColor: themeColor.main,
                    color: themeColor.main,
                    '& .MuiChip-icon': {
                        color: themeColor.main,
                        fontSize: '14px',
                    },
                }),
            }}
        />
    );
}

export default AvailabilityBadge;
